import React from 'react';
import prefectureList from '../../constant/prefecture';

interface SelectPrefectureType {
    value: string,
    errorMessage?: string,
    onChange: (value: string) => void,
}

const SelectPrefecture: React.FC<SelectPrefectureType> = ({value, errorMessage, onChange}) => {
    return (
        <div>
            <div className="flex flex-row">
            <select
                name="companyPrefecture"
                className="form-input bg-white"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                required
            >
                <option value="" disabled>都道府県を選択</option>
                {prefectureList.map((item, index) => <option value={item.name} key={index}>{item.name}</option>)}
            </select>
            </div>
            {errorMessage && <div className="form-error text-red-500 text-sm mt-1">{errorMessage}</div>}
        </div>
    )
}

export default SelectPrefecture;